import React, { useEffect, useState } from "react";
import Event from "../CreateEvent";
import { getData } from "utils/queries";
import { useParams } from "react-router-dom";
import { formatDateTimeRange, getDateTimeFromDate, getTimezoneFromRegion } from "utils";

const EditEvent = () => {
  const [event, setEvent] = useState({});
  const [userRegion, setUserRegion] = useState(null);
  const { event_id } = useParams();

  // Get user's region - could be from user preferences, browser settings, etc.
  useEffect(() => {
    // Example: Get region from localStorage or user preferences
    const region = localStorage.getItem('userRegion') || 'UK'; // Default to UK if not set
    setUserRegion(region);    
    
    // Alternative: Get browser timezone and map to a region
    // const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timezone;
    // const regionFromTimezone = mapTimezoneToRegion(browserTimezone);
    // setUserRegion(regionFromTimezone);
    
  }, [ userRegion ]);

  const fetchEventDetails = async (event_id) => {
    try {
      const result = await getData(`event/events/${event_id}`);

      const events = result?.data?.data?.events;
      const question = result?.data?.data?.questions;
      const incentives = result?.data?.data?.incentives;

      // Get timezone from region
      const timezone = userRegion ? getTimezoneFromRegion(userRegion) : 'UTC';

      // Get date/time with timezone consideration
      const { date: lastDate, hours: lastHours, minutes: lastMinutes } = 
        getDateTimeFromDate(events?.last_entry_time, timezone);
        
      const { date: startDate, hours: startHours, minutes: startMinutes } = 
        getDateTimeFromDate(events?.starts, timezone);
        
      const { date: endDate, hours: endHours, minutes: endMinutes } = 
        getDateTimeFromDate(events?.ends, timezone);

      // Format date and time range with region/timezone
      const updatedDateAndTime = formatDateTimeRange(
        events.starts, 
        events.ends, 
        events.last_entry_time,
        userRegion
      );

      const modifiedData = {
        question,
        incentives,
        ...events,
        organiser_name: { label: events?.name, value: events?.organiser_name },
        
        // Last entry time
        last_entry_time: lastDate,
        lastEndHours: updatedDateAndTime.lastHours || { label: lastHours, value: lastHours },
        lastEndMinutes: updatedDateAndTime.lastMinutes || { label: lastMinutes, value: lastMinutes },
        
        // Start time
        starts: startDate,
        startHours: { label: updatedDateAndTime.startHours.label, value: updatedDateAndTime.startHours.value },
        startMinutes: { label: updatedDateAndTime.startMinutes.label, value: updatedDateAndTime.startMinutes.value },
        
        // End time
        ends: endDate,
        endHours: { label: updatedDateAndTime.endHours.label, value: updatedDateAndTime.endHours.value },
        endMinutes: { label: updatedDateAndTime.endMinutes.label, value: updatedDateAndTime.endMinutes.value },
        
        // Add timezone/region info
        timezone: updatedDateAndTime.timezone,
        region: userRegion
      };
    
      setEvent(modifiedData);
    } catch (error) {
      console.error("Error fetching event details:", error);
    }
  };

  useEffect(() => {
    if (event_id) {
      fetchEventDetails(event_id);
    }
  }, [event_id]);

  return <Event data={event} event_id={event_id} />;
};

export default EditEvent;